/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import { ListView } from "antd-mobile";
import LoadmoreFooter from "../LoadmoreFooter";
import ReviewItem from "../ReviewItem";
import EmptyReview from "../EmptyReview";
import * as reviewSelectors from "../../selectors/review";
import "./index.css";

class ReviewListing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasMore: true,
      isLoading: false
    };
  }

  onEndReached = event => {
    const { onEndReached } = this.props;

    onEndReached && onEndReached();
  };

  render() {
    const { items, renderHeader, showFooterLoading } = this.props;
    const dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2
    });

    return (
      <ListView
        className={"review-listing"}
        ref={el => (this.lv = el)}
        dataSource={dataSource.cloneWithRows(items)}
        renderHeader={() => renderHeader && renderHeader()}
        renderFooter={() => <LoadmoreFooter loading={showFooterLoading} />}
        renderRow={data => {
          const id = reviewSelectors.getReviewID(data);
          const userName = reviewSelectors.getReviewUserName(data);
          const displayTime = reviewSelectors.getReviewRelativeTime(data);
          const rating = reviewSelectors.getReviewRating(data);
          const comment = reviewSelectors.getReviewComment(data);

          return data.type === "empty" ? (
            <EmptyReview />
          ) : (
            <ReviewItem
              id={id}
              name={userName}
              date={displayTime}
              rating={rating}
              // title={comment}
              description={comment}
            />
          );
        }}
        pageSize={10}
        scrollRenderAheadDistance={500}
        onEndReached={this.onEndReached}
        onEndReachedThreshold={800}
        style={{
          height: "100%",
          width: "100%"
        }}
      />
    );
  }
}

ReviewListing.propTypes = {
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired,
  showFooterLoading: PropTypes.bool,
  renderHeader: PropTypes.func,
  onEndReached: PropTypes.func
};

ReviewListing.defaultProps = {
  items: []
};

export default ReviewListing;



// WEBPACK FOOTER //
// ./src/components/ReviewListing/index.js